<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="当日套利成交汇总"
        name="arbitrageTransactionInquiry"
      >
        <arbitrageTransactionInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="当日套利成交明细"
        name="arbitrageTransactionDetails"
      >
        <arbitrageTransactionDetails />
      </el-tab-pane>
      <el-tab-pane
        label="历史套利成交汇总"
        name="historicalArbitrageTransactionInquiry"
      >
        <historicalArbitrageTransactionInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史套利成交明细"
        name="historicalArbitrageTransactionDetails"
      >
        <historicalArbitrageTransactionDetails />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import arbitrageTransactionInquiry from './arbitrage-transaction-inquiry'
import arbitrageTransactionDetails from './arbitrage-transaction-details'
import historicalArbitrageTransactionInquiry from './historical-arbitrage-transaction-inquiry'
import historicalArbitrageTransactionDetails from './historical-arbitrage-transaction-details'
export default {
  name: 'Index',
  components: {
    arbitrageTransactionInquiry,
    arbitrageTransactionDetails,
    historicalArbitrageTransactionInquiry,
    historicalArbitrageTransactionDetails
  },
  data () {
    return {
      activeName: 'arbitrageTransactionInquiry',
    }
  }
}

</script>
